// extracted by mini-css-extract-plugin
module.exports = {"SliderBlock":"_23w0xe"};